import React, { useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import './dashboard.css';

function Dashboard() {
  const breadcrumbItems = [{ label: 'Dashboard' }];
  const [showModal, setShowModal] = useState(false);
  const [activeTitle, setActiveTitle] = useState('');

  const openModal = (title) => {
    setActiveTitle(title);
    setShowModal(true);
  };

  return (
    <>
      <div className={showModal ? 'page-dimmed' : ''}>
        <Breadcrumb items={breadcrumbItems} />

        <div className="card">
          <div className="card-body">
            {/* <h1 className="mb-4">Dashboard</h1> */}

            {/* === ROW ATAS === */}
            <div className="row mb-4">
              {['Project', 'Project Current', 'Project Closing'].map((item) => (
                <div className="col-md-4" key={item}>
                  <div
                    className="card bg-primary text-white text-center dashboard-box"
                    onClick={() => openModal(item)}
                  >
                    <div className="card-body fw-bold">{item}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* === ROW TENGAH === */}
            <div className="row mb-4">
              <div className="col-md-3">
                <div
                  className="card bg-primary text-white text-center dashboard-box"
                  onClick={() => openModal('< 60%')}
                >
                  <div className="card-body fw-bold">&lt; 60%</div>
                </div>
              </div>
              <div className="col-md-3">
                <div
                  className="card bg-success text-white text-center dashboard-box"
                  onClick={() => openModal('61% - 70%')}
                >
                  <div className="card-body fw-bold">61% - 70%</div>
                </div>
              </div>
              <div className="col-md-3">
                <div
                  className="card bg-warning text-white text-center dashboard-box"
                  onClick={() => openModal('71% - 85%')}
                >
                  <div className="card-body fw-bold">71% - 85%</div>
                </div>
              </div>
              <div className="col-md-3">
                <div
                  className="card bg-danger text-white text-center dashboard-box"
                  onClick={() => openModal('> 85%')}
                >
                  <div className="card-body fw-bold">&gt; 85%</div>
                </div>
              </div>
            </div>

            {/* === ROW BAWAH === */}
            <div className="row">
              <div className="col-md-3">
                <div
                  className="card bg-primary text-white text-center dashboard-box"
                  onClick={() => openModal('Keuntungan Bagus')}
                >
                  <div className="card-body fw-bold">
                    Keuntungan Bagus <br /> &gt; 12%
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div
                  className="card bg-success text-white text-center dashboard-box"
                  onClick={() => openModal('Untung Normal')}
                >
                  <div className="card-body fw-bold">
                    Untung Normal <br /> 5% - 12%
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div
                  className="card bg-warning text-white text-center dashboard-box"
                  onClick={() => openModal('Tidak Rugi')}
                >
                  <div className="card-body fw-bold">
                    Tidak Rugi <br /> 0 - 5%
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div
                  className="card bg-danger text-white text-center dashboard-box"
                  onClick={() => openModal('Rugi')}
                >
                  <div className="card-body fw-bold">
                    Rugi <br /> &lt; 0
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* === MODAL === */}
      {showModal && (
        <>
          <div className="modal-backdrop-custom"></div>

          <div className="modal d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{activeTitle}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Year</th>
                        <th>Project</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>{/* data masih kosong */}</tbody>
                  </table>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Tutup
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Dashboard;
